module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "assets/download.worker.0a24861ff49afcc2f2f9.js");
}
